import { MapType, MapMarkerResponse, MapMarkersRequest } from '../types/maps';
import { goClient } from '../utils/httpClientTs';

// Real API functions
export const getMapTypes = async (): Promise<MapType[]> => {
  console.log(
    '🗺️ API Call: GET /maps/types (using hardcoded types until backend endpoint is ready)'
  );

  // TODO: When backend implements GET /maps/types endpoint, replace with:
  // return get<MapType[]>('/maps/types');

  // Hardcoded types for now (matches backend enum: 'chapters', 'members')
  return [
    { id: 'chapters', name: 'Chapters' },
    { id: 'members', name: 'Members' },
  ];
};

export const getMapMarkers = async (
  request: MapMarkersRequest
): Promise<MapMarkerResponse> => {
  const response = await goClient({
    url: `/maps/markers`,
    method: 'POST',
    data: request,
  });
  return response.data;
};

// Utility function to get postal code coordinates
// Note: This is handled client-side using Mapbox Geocoding API in the Map component
// This function is kept as a fallback for testing purposes
export const getPostalCodeCoordinates = async (
  postalCode: string
): Promise<{ lat: number; lng: number }> => {
  console.log('🗺️ Fallback API Call: GET /geocoding/postal-code', {
    postalCode,
  });

  // Fallback coordinates for common postal codes (used only if Mapbox fails)
  const fallbackCoordinates: { [key: string]: { lat: number; lng: number } } = {
    '90210': { lat: 34.0901, lng: -118.4065 }, // Beverly Hills, CA
    '10001': { lat: 40.7505, lng: -73.9934 }, // New York, NY
    '60601': { lat: 41.8781, lng: -87.6298 }, // Chicago, IL
    '33101': { lat: 25.7617, lng: -80.1918 }, // Miami, FL
    '98101': { lat: 47.6062, lng: -122.3321 }, // Seattle, WA
    '75201': { lat: 32.7767, lng: -96.797 }, // Dallas, TX
    '30301': { lat: 33.749, lng: -84.388 }, // Atlanta, GA
    '02101': { lat: 42.3601, lng: -71.0589 }, // Boston, MA
  };

  return fallbackCoordinates[postalCode] || { lat: 39.8283, lng: -98.5795 }; // Default to center of US
};
